import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { BaseComponent } from '../../../shared/class/base-component.class';
import { RequestStatus } from '../../../shared/enums/request-status.enum';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { MessageType } from '../../../shared/enums/message-type.enum';
import { ImportMatchingModule } from '../../import-matching.module';
import { FileUploadReq } from '../../../matching/models/file-upload-req';
@Component({
  selector: 'app-matching-container',
  templateUrl: './import-matching-container.component.html',
  styleUrl: './import-matching-container.component.scss',

})
export class ImportMatchingContainerComponent extends BaseComponent {
  reconciliation: any[] = []
  fileData: any = [] = [];
  downloadData: any;
  errorTitle:string = '';


  constructor(private http: HttpClient, private confirmationService: ConfirmationService) {
    super();
  }

  generateErrorMessage(obj: any) {
    if (obj.error.validationError && obj.error.columns && Array.isArray(obj.error.columns)) {
      const missingColumns = obj.error.columns.join(', ');
      return `The following ${obj.type}(s) are missing: <strong>${missingColumns}</strong>.<br /> Please add these ${obj.type}s.`;
    }
    return;

  }

  copyToClipboard(text: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.notificationService.notify(`Copied to clipboard: ${text} `, MessageType.Info);
  }

  async fileUpload(data: FileUploadReq) {
    let body: FormData = new FormData();
    data.files.forEach((file: File) => {
      body.append('files', file, file.name);
    });
    body.append('data', JSON.stringify(data.data));
    this.requestStatus = RequestStatus.Inprogress;
    let response: ApiResponse<any[]> =
      await this.httpService.httpRequest<any[]>(
        "matching",
        "import-gst-2b",
        body,
        {
          showLoader: false
        }
      );
    if (response.status && response.data) {
      this.fileData = response.data;
      this.requestStatus = RequestStatus.Completed;
      this.notificationService.showSuccess('File uploaded Successfully')
    } else {


      if ((response as any)?.validationError) {
        this.requestStatus = RequestStatus.None;
        this.errorTitle = response.error.title;
        this.confirmationService.confirm({
          header: response.error.title,
          message: response.error.message,
          acceptButtonStyleClass: 'p-button-danger p-button',
        });
        return;
      }
      this.notificationService.showError(response.message)
      this.requestStatus = RequestStatus.None;
      // if (response.error) {
      //   this.notificationService.showError(response.error.message);
      //   return;
      // }
      // this.notificationService.showError(response.error.message)
      // this.requestStatus = RequestStatus.None;

    }
  }

  onReset() {
    this.requestStatus = RequestStatus.None;
  }

}
